import { ReactElement } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import { overflowCountChip } from 'app/components/table/cellInteraction'

/** The normalized "+N" overflow indicator for chip rows in table cells.
 *  Passive by design (neutral fill, default cursor); the tooltip lists what's hidden. */
export function OverflowCountChip({ items }: { items: string[] }): ReactElement | null {
  if (items.length === 0) return null
  return (
    <Tooltip
      message={
        <div>
          {items.map((item) => (
            <div className="py-0.5" key={item}>
              {item}
            </div>
          ))}
        </div>
      }
    >
      <div className={overflowCountChip}>{`+${items.length}`}</div>
    </Tooltip>
  )
}
